:host {
  display: block;
}

h1 {
  color: rgb(46, 82, 118);
  font-size: 56px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: -1.5px;
  line-height: 72px;
}
